import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UserApiService} from '../../../../projects/api/src/user/user-api.service';
import {LocalStorageService} from '../../../../projects/api/src/locale-storage/locale-storage.service';
import { ConfigureService } from '../../../../projects/common/modules/configure/configure.service';
import {ApplicationsApiService} from "../../../../projects/api/src/applications/applications-api.service";

export interface Theme {
  cssClass: string;
  name: string;
  id: number;
  icon: string;
  colorScheme;
}

export enum ThemeEnum {
  'LightTheme',
  'DarkTheme',
  'ContrastTheme',
  'GreenTheme',
  'BlueTheme'
}


@Injectable()
export class ThemeService {
  public theme: BehaviorSubject<Theme>;

  constructor(private userApi: UserApiService, private localStorageApi: LocalStorageService, private configService: ConfigureService, private applicationsApi: ApplicationsApiService) {
    this.initConfig();
    console.log(this._themes[0]);

    this.theme = new BehaviorSubject<Theme>(this._themes[0]);
    this.initService();
  }

  public current: Theme;

  private _themes: Theme[] = [
    {icon: 'u-text-black', cssClass: 'theme-dark', name: 'DarkTheme', colorScheme: 'dark', id: ThemeEnum.DarkTheme},
    {icon: 'u-text-white', cssClass: 'theme-light', name: 'LightTheme', colorScheme: 'light', id: ThemeEnum.LightTheme},
    {icon: 'u-text-white', cssClass: 'theme-contrast', name: 'ContrastTheme', colorScheme: 'light', id: ThemeEnum.ContrastTheme},
    {icon: 'theme-green-circle', cssClass: 'theme-green', name: 'GreenTheme', colorScheme: 'light', id: ThemeEnum.GreenTheme},
    {icon: 'theme-blue-circle', cssClass: 'theme-blue', name: 'BlueTheme', colorScheme: 'dark', id: ThemeEnum.BlueTheme},
  ];

  get themes(): Theme[] {
    return this._themes;
  }

  public setTheme(theme: Theme, applicationCode: number | string) {
    this.localStorageApi.save(true, 'theme', theme.id + '');
    this.current = theme;
    // this.theme.next(this._themes.find(_theme => _theme.id === theme));
    const userApp = this.applicationsApi.config.find(app => app.code === applicationCode);
    if (userApp) {
      if (this.configService.options.userApp?.id) {
        const newUserApp = {
          ...this.configService.options.userApp,
          theme: theme.id
        }
        this.applicationsApi.updateUserApplication(newUserApp).subscribe(result => console.log(result));
      } else {
        this.applicationsApi.crateUserApplication({
          application: userApp,
          theme: theme.id
        }).subscribe(result => console.log(result));

      }
    }

    this.userApi.setProfileTheme(theme.id).subscribe(() => {
      this.theme.next(theme);
    });
  }


  private initConfig() {
    if (this.configService.options?.themes) {
      this._themes = this.configService.options.themes;
    }
  }
  private initService() {
    this.theme.subscribe(selectedTheme => {
        const theme = selectedTheme || this._themes[0];
        if (!theme) {
          return;
        }
        this.current = theme;
        this._themes.forEach(_theme => document.body.classList.remove(_theme.cssClass));
        document.body.classList.add(theme.cssClass);
      }
    );
  }
}
